<h1 i18n="domains|Page title">Reseller domains</h1>

<app-paginated-table
  [columns]="columns"
  [filters]="filters"
  [query]="domainsGQL"
  [dataMapper]="dataMapper"
  (rowClick)="onDomainClick($event)"
  (selectionChange)="onSelectionChange($event)"
  (selectAllChange)="onSelectAllChange($event)"
  (orderByChange)="onOrderByChange($event)"
  (filterQueryParameterChange)="onFilterQueryParameterChange($event)"
  >
</app-paginated-table>

<p-toolbar>
  <div class="p-toolbar-group-start">
    <p-button icon="pi pi-download" label="Export" (click)="onExportClick()" i18n="domains|Export button"></p-button>
  </div>
</p-toolbar>

<p-dialog [modal]="true" [(visible)]="exportFieldGroupsDialogVisible" [style]="{ margin: '10px' }">
  <ng-template pTemplate="header">
    <span class="p-dialog-title" i18n="domains|Export fields dialog header">Fields to export</span>
  </ng-template>
  <div class="export-fields-container">
    @for (fieldGroup of exportFieldGroups; track fieldGroup) {
      <div class="export-field-group-container">
        <h6>{{ fieldGroup.label }}</h6>
        <ul>
          @for (field of fieldGroup.fields; track field) {
            <li>
              <p-checkbox [inputId]="field.value" [value]="field.value" [(ngModel)]="selectedExportFields"></p-checkbox>
              <label [for]="field.value">{{ field.label }}</label>
            </li>
          }
        </ul>
      </div>
    }
    <div>
      <p-button icon="pi pi-download" label="Export" (click)="onExportConfirm()" i18n="domains|Export confirm button"></p-button>
    </div>
  </div>
</p-dialog>